var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuarters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}.cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quarters") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quarters"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.09 58.04 58.3 25.42 64.86 19.16 70.98 25 105.62 58.04 24.09 58.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.88 52.68 54.53 50.05 54.53 35.84 64.88 38.47 64.88 52.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.32 50.18 64.97 52.81 64.97 38.6 75.32 35.97 75.32 50.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.48,
    y: 58.04,
    width: 86.75,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.09,
    y: 100.4,
    width: 81.81,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 105.04,
    width: 94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.72,
    y: 62.97,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.72,
    y: 95.46,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.75,
    y: 67.9,
    width: 7.87,
    height: 27.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.83,
    y: 62.97,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.83,
    y: 95.46,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.86,
    y: 67.9,
    width: 7.87,
    height: 27.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.95,
    y: 62.97,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.95,
    y: 95.46,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.98,
    y: 67.9,
    width: 7.87,
    height: 27.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.06,
    y: 62.97,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.06,
    y: 95.46,
    width: 13.93,
    height: 4.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.09,
    y: 67.9,
    width: 7.87,
    height: 27.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarters);
export default __webpack_public_path__ + "static/media/quarters.18b9e5b3a5f35254dec94b92c97d5c89.svg";
export { ForwardRef as ReactComponent };